import { AppLayout, Box, Button, Flashbar, FlashbarProps, Header, SpaceBetween, Table } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { McpConfig } from 'src/components/context/AppContextModels';
import { appLayoutAriaLabels } from 'src/i18n-strings';
import { AdminSideNavigationV2 } from '../AdminSideNavigationV2';
import { MCP_SERVERS_TABLE_COLUMNS } from './McpServersConfig';
import { useMcpConfigs } from './useMcpConfigs';

export const McpServersAdmin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mcpConfigs, isLoading } = useMcpConfigs();

  const [flashMessages, setFlashMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

  useEffect(() => {
    const navigationState = location.state as { message?: { type: FlashbarProps.Type; content: string; header: string } } | null;
    if (navigationState?.message) {
      setFlashMessages([
        {
          type: navigationState.message.type,
          content: navigationState.message.content,
          header: navigationState.message.header,
          dismissible: true,
          onDismiss: () => setFlashMessages([])
        }
      ]);
      // Clear navigation state to prevent stale messages on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <AppLayout
      ariaLabels={appLayoutAriaLabels}
      toolsHide={true}
      navigation={<AdminSideNavigationV2 />}
      stickyNotifications
      notifications={<Flashbar items={flashMessages} />}
      contentType="table"
      content={
        <Table<McpConfig>
          items={mcpConfigs}
          loading={isLoading}
          loadingText="Loading MCP servers..."
          columnDefinitions={MCP_SERVERS_TABLE_COLUMNS}
          variant="full-page"
          stickyHeader={true}
          header={
            <Header
              variant="h1"
              actions={
                <SpaceBetween size="xs" direction="horizontal">
                  <Button variant="primary" onClick={() => navigate('/admin/manage-mcp-server')}>
                    Add MCP Server
                  </Button>
                </SpaceBetween>
              }
              counter={`(${mcpConfigs.length})`}
            >
              MCP Servers
            </Header>
          }
          empty={
            <Box textAlign="center" color="inherit">
              <b>No MCP Servers Configured</b>
              <Box padding={{ bottom: 's' }} variant="p" color="inherit">
                Create your first MCP server configuration.
              </Box>
            </Box>
          }
        />
      }
    />
  );
};

export default McpServersAdmin;
